export const clickOnSearchBarSelector = ({clickOnSearchBar}) => clickOnSearchBar